import { api } from '../../api/client';
import { useApi } from '../../hooks/useApi';
import { Spinner } from '../ui';
import { GlobalContactPicker } from './DealPickers';

// Contacts tab — works at deal level (dealId only) or detail level (dealId + dealDetailId).
export const DealContactsTab = ({ dealId, dealDetailId }) => {
  const params = dealDetailId
    ? `dealId=${dealId}&dealDetailId=${dealDetailId}`
    : `dealId=${dealId}`;
  const { data: contacts, loading, reload } = useApi(
    () => api.get(`contacts/for-deal?${params}`),
    [dealId, dealDetailId]
  );
  if (loading) return <Spinner />;
  return (
    <GlobalContactPicker
      linkedContacts={contacts || []}
      dealId={dealId}
      dealDetailId={dealDetailId}
      onChanged={reload}
    />
  );
};
